<template> 
    <v-container class="app-page-container">
				<v-card class="shadow-none app-page-card" v-if="queList">
            
                  <v-card-title >
                    <v-flex xs6>
                        My questionaires
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="leaderboard">
                      <v-layout row wrap class="leaderboard__head">
                        <v-flex xs1> 
                        </v-flex>
                        <v-flex xs4> 
                          name
                        </v-flex>
                        <v-flex xs3> 
                          course
                        </v-flex>
                        <v-flex xs1> 
                          status
                        </v-flex>
                        <v-flex xs1> 
                          score
                        </v-flex>
                        <v-flex xs2> 
                          created at
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap v-for="(que, index) in queList" :key="index" @click="openQuestionaire(que.id)" class="leaderboard__row"> 
                        <v-flex xs1></v-flex> 
                        <v-flex xs4> {{que.content}} </v-flex>
                        <v-flex xs3> {{que.course_name}} </v-flex>
                        <v-flex xs1> {{que.q_status}} </v-flex>                
                        <v-flex xs1> {{que.score}} </v-flex>                
                        <v-flex xs2> {{que.created_at}} </v-flex>
                      </v-layout>
                  </v-card-text>

      </v-card> 
	</v-container>      
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
      return {
        queList: null,
        feedback: null,
      }
    },
    mounted () {
      this.initData()
   },
   methods: {
    initData() {
      this.$store.commit('setBreadCrumbs',[{text: 'My questionnaires', href: '/myquestionnaires'}])//#
      this.getQuestionaires()
    },
    getQuestionaires() {
      axios.get('/get-my-questionaires', this.$store.getters.getAxiosConfig)
        .then(res => {         
            this.queList = res.data.list            
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    openQuestionaire(id) {
        this.$router.push({name:'myquestionnaire', params: {id: id}})        
    }
   }
  }
</script>
